import { Stack } from "@mantine/core";
import { AccessChecker } from "components/auth/AccessChecker";
import { ProjectDocsBlock } from "components/project/_blocks/ProjectDocBlock";
import { LimitedAccessComponent } from "components/_common/LimitedAccessComponent";
import { useMobile } from "shared/hooks/useMobile";
import { useWindowScrollToPosition } from "shared/hooks/useWindowScrollToPosition";

export const ProjectDocsPage = () => {
  const { setOption } = useMobile();
  const ref = useWindowScrollToPosition(setOption(-150, -200));

  return (
    <Stack ref={ref}>
      <AccessChecker rejectChildren={<LimitedAccessComponent />}>
        <ProjectDocsBlock />
      </AccessChecker>
    </Stack>
  );
};
